import React from 'react'
import { Icon } from 'semantic-ui-react'

import './TranscriptionStatus.css'

export default ({ transcription }) => {
  const status = transcription.transcriptionJob
    ? transcription.transcriptionJob.TranscriptionJobStatus
    : 'pending'

  const props = {}
  if (status === 'IN_PROGRESS') {
    props.icon = 'clock'
    props.color = '#545b64'
    props.text = 'In progress'
  } else if (status === 'FAILED') {
    props.icon = 'remove circle'
    props.color = '#B03060'
    props.text = 'Failed'
  } else if (status === 'COMPLETED') {
    props.icon = 'check circle'
    props.color = '#016936'
    props.text = 'Completed'
  } else {
    props.icon = 'hourglass'
    props.color = '#A0A0A0'
    props.text = 'Pending'
  }

  return (
    <div style={{ color: props.color }} className='TranscriptionStatus'>
      <Icon name={props.icon} />{props.text}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/TranscriptionStatus.js